var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSpeed = function SvgSpeed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    rx: 3.139,
    fill: "#E5EFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55 50.157 16.774-21.585a.785.785 0 0 1 1.363.735L63.948 56.31",
    stroke: "#0171B7",
    strokeWidth: 2.354
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.57
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.32 34.048v5.098",
    stroke: "#FAA61A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.57 31.298h-5.098",
    stroke: "#F9AD2E"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FAA61A",
    d: "m92.777 36.909-3.667-3.542M84.299 28.722l-3.667-3.542"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FAA61A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m80.342 37.062 3.667-3.542M87.996 29.67l5.095-4.92"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FAA61A",
    d: "M86.166 22.262v4.714M95.202 30.512h-4.714"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m56.644 51.391 5.33 3.161a3.14 3.14 0 0 1 1.538 2.7v5.952a3.14 3.14 0 0 1-1.532 2.697l-5.373 3.201a3.14 3.14 0 0 1-3.214 0l-5.29-3.152a3.14 3.14 0 0 1-1.53-2.84l.273-5.999a3.14 3.14 0 0 1 1.473-2.52l5.06-3.162a3.14 3.14 0 0 1 3.265-.038zM24.226 60.238c1.34-17.017 16.22-29.726 33.237-28.386 2.134.168 4.244.557 6.297 1.16l.407.12M74.643 38.631c6.539 3.439 10.468 10.423 11.786 20.952M43.214 74.97H67.44",
    stroke: "#0171B7",
    strokeWidth: 3.139
  }))));
};
export default SvgSpeed;